import { baseApi } from 'lib/rtkQuery/baseApi';
import { QueryResponse } from 'lib/rtkQuery/types';
import { TGetMeResponse } from './types';

const endpoint = '/account';

export const accountQueryApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    GetMe: builder.query<QueryResponse<TGetMeResponse>, void>({
      query: () => ({
        url: `${endpoint}/get-me`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetMeQuery } = accountQueryApi;
